import { render, staticRenderFns } from "./coverTop.vue?vue&type=template&id=478dca1b&scoped=true&"
import script from "./coverTop.vue?vue&type=script&lang=js&"
export * from "./coverTop.vue?vue&type=script&lang=js&"
import style0 from "./coverTop.vue?vue&type=style&index=0&id=478dca1b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478dca1b",
  null
  
)

export default component.exports